module.exports = __webpack_public_path__ + "img/img_index_banner_t@2x.703371f1.png";